export default __webpack_public_path__ + "static/media/Tours.48e9d9b7.jpg";